import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from './store'
const fb = require("./fbConfig");

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyAH_7b8EuqS3NZEy1eNB_S2U_NQG7L2nxU',
      libraries: 'places',
    },
  })

Vue.config.productionTip = false;

let app
fb.auth.onAuthStateChanged( user => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App)
        })
    }
})

